import { render, staticRenderFns } from "./LogElement.vue?vue&type=template&id=1b2d9ee8&"
import script from "./LogElement.vue?vue&type=script&lang=ts&"
export * from "./LogElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports